import StudentAttendanceComponent from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentAttendanceComponent";
import StudentInformationComponent from "Pages/StudentPortfolio/StudentPerfomanceSection/StudentInformance/StudentInformationComponent";
import { Card, Col, Row, Spinner } from "reactstrap";
import styled from "styled-components";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
import { StudentContext } from "Context/StudentContext";
import { useContext, useEffect, useState } from "react";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  BASE_URL,
  GET_ATTENDANCE_COUNT,
} from "utilFunctions/Constants/urlConstants";
const StudentInformanceMainCol = styled<any>(Col)`
  display: flex;
  margin-left: 0px;
  border-right: ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen)
      ? "1px solid var(--Grey-20, #eee)"
      : "none"};
  padding-left: 16px;
  display: flex;
  width: 414px;
  padding:  ${(props: any) =>
    ["xl", "xxl", "lg"].includes(props.screen) ? "16px 16px 0px 16px" : "12px"};
  align-items: center;
}
`;
const StudentInformanceMain = ({ selectStudentDetailHandler }: any) => {
  const ToastDispatch = useContext<any>(ToastContextDispatch);
  const { selectedStudent, lopDetails } = useContext<any>(StudentContext);
  const [attendanceCount, setAttendanceCount] = useState<any>({});
  const { screen }: any = useWindowSize();
  const { makeRequest: GetAttendanceCount, loading: isAttendanceCountLoader } =
    useGetApi(
      (res) => {
        if (res.data && res.data) {
          setAttendanceCount(res.data);
        } else {
          setAttendanceCount({});
        }
      },
      (error) => {
        console.log(error);
        setAttendanceCount({});
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      }
    );

  useEffect(() => {
    if (selectedStudent && selectedStudent.psid) {
      GetAttendanceCount(
        BASE_URL + GET_ATTENDANCE_COUNT + "?psid=" + selectedStudent.psid
      );
    }
  }, [selectedStudent]);
  return (
    <Card
      className={
        ["xl", "xxl", "lg"].includes(screen)
          ? "studentInformanceMainCard"
          : "studentInformanceMainCardMB"
      }
    >
      <Row>
        <StudentInformanceMainCol
          screen={screen}
          xxl="6"
          xl="6"
          lg="6"
          md="12"
          sm="12"
          xs="12"
        >
          <StudentInformationComponent
            selectStudentDetailHandler={selectStudentDetailHandler}
            selectedStudent={selectedStudent}
            lopDetails={lopDetails}
          />
        </StudentInformanceMainCol>
        {isAttendanceCountLoader ? (
          <div className="d-flex justify-content-center align-items-center">
            <Spinner color="info"></Spinner>
          </div>
        ) : (
          <Col
            xxl="6"
            xl="6"
            lg="6"
            md="12"
            sm="12"
            xs="12"
            className={
              ["xxl", "xl", "lg"].includes(screen)
                ? "StudentAttendanceComponentCol"
                : "StudentAttendanceComponentColMB"
            }
          >
            <StudentAttendanceComponent
              attendanceCount={attendanceCount}
              selectedStudent={selectedStudent}
              lopDetails={lopDetails}
            />
          </Col>
        )}
      </Row>
    </Card>
  );
};
export default StudentInformanceMain;
